import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const images = [
  { src: "images/spot-1.png", width: 319, height: 566 },
  { src: "images/spot-2.png", width: 319, height: 566 },
  { src: "images/spot-3.png", width: 319, height: 566 },
  { src: "images/spot-1.png", width: 319, height: 566 },
  { src: "images/spot-2.png", width: 319, height: 566 },
  { src: "images/spot-3.png", width: 319, height: 566 },
];

const Spotlight = () => {
  const autoplayConfig = {
    delay: 4000,
    disableOnInteraction: false,
  };

  const breakpointsConfig = {
    1024: {
      slidesPerView: 3,
      spaceBetween: 40,
      centeredSlides: false,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
      centeredSlides: false,
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 10,
      centeredSlides: false,
    },
  };

  return (
    <section className="spotlight">
      <div className="container-xl">
        <div className="row">
            <div className="heading-area">
              <h2>
                Adored by <span>Couples</span> From all around the world – Get
                Skin Ready for the Spotlight
              </h2>
            </div>
            <div className="swiper spotlight-carousel">
              <Swiper
                modules={[Navigation, Autoplay]}
                slidesPerView={1}
                spaceBetween={0}
                centeredSlides={true}
                autoplay={autoplayConfig}
                loop={true}
                navigation={{
                  nextEl: ".spotlight-swiper-button-next",
                  prevEl: ".spotlight-swiper-button-prev",
                }}
                breakpoints={breakpointsConfig}
              >
                {images.map((image, index) => (
                  <SwiperSlide key={index}>
                    <img src={image.src} width={image.width} height={image.height} alt={`Image ${index + 1}`} />
                  </SwiperSlide>
                ))}
              </Swiper>

              {/* Navigation Buttons */}
              <div className="swiper-button-next spotlight-swiper-button-next"></div>
              <div className="swiper-button-prev spotlight-swiper-button-prev"></div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default Spotlight;
